import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '/node_modules/bootstrap/dist/js/bootstrap.min.js';
import '/node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../src/pages/home.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <App />
);


